<template>
    <div class="card mt-4 bg-primary-soft" @click="handleCopy">
        <div class="card-body">
            <div class="row align-items-center d-flex">
                <div class="col-9 fw-bold">
                    {{ limitedCode }}
                </div>
                <div class="col-3 text-end">
                    <button class="btn btn-link fs-2 p-0"><i class="far fa-copy"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import useToast from '@/composables/useToast';
import { computed } from 'vue';
const { toastSuccess } = useToast()
const props = defineProps<{
    code: string
}>()

const limitedCode = computed(() => props.code)

const handleCopy = () => {
    navigator.clipboard.writeText(props.code);
    toastSuccess('Código copiado!')
}
</script>